
export default {
  methods: {
    _getStopCalls (latitude, longitude, radius) {
      return this.$http.post('stops/nextPassages', { latitude, longitude, radius }, this.completeHttpParams({})).then(response => response.body)
    },
    _getStopCalls2 (stopId) {
      return this.$http.post('stops/nextPassages', { stopId }, this.completeHttpParams({})).then(response => response.body)
    },
    _getNearbyStops (latitude, longitude, radius) {
      return this.$http.post('stops/nearby', { latitude, longitude, radius }, this.completeHttpParams({})).then(response => response.body)
    }
  }
}